export default __webpack_public_path__ + "static/media/2108.ca1b76b1.png";